/**
 * Alipay HK icon URL
 * Hong Kong's mobile payment platform
 * Source: Airwallex documentation
 * Used for payment method selection UI
 */
export const ALIPAYHK_ICON_DATA_URL =
  'https://www.airwallex.com/docs/assets/contentful/images.ctfassets.net/c3n7jozh84hr/3sNSjVq0K9mq5whYcGJhBe/78857434adff807c8e293425491e0bd4/AlipayHK.svg';
